<template>
  <div>
    <portal to="page-top-title">Category #{{ id }}</portal>
    <portal to="page-top-right">
      <btn :route="{ name: 'templates-categories-edit', params: { id: id } }" icon="fa-edit" text>Edit</btn>
    </portal>

    <box-single :url="`/templates/categories/${id}`" data-prop="category" resp-prop="data" loader>
      <template slot="content">
        <row>
          <column-info title="Name">{{ category.name }}</column-info>
          <column-info title="Group" v-if="category.group">
            <router-link :to="{ name: 'categoryGroups-single', params: { id: category.group.id } }">{{ category.group.name }}</router-link>
          </column-info>
          <column-info title="Created At">{{ category.created_at }}</column-info>
          <column-info title="Updated At">{{ category.updated_at }}</column-info>
        </row>
        <row>
          <column-info title="Active">
            <badge-active :value="category.active"/>
          </column-info>
          <column-info title="Templates">
            <badge title="Total">{{ category.templates_count_total }}</badge>
            <badge title="Active" color="green">{{ category.templates_count_active }}</badge>
            <badge title="Inactive" color="red">{{ category.templates_count_inactive }}</badge>
          </column-info>
        </row>
      </template>
    </box-single>

    <box-table title="Templates" :url="`/templates`" :url-query="{ category_id: id }" data-prop="templates" loader>
      <template slot="box-tools-right">
        <btn :route="{ name: 'templates-new', query: { category: id }}" size="xs" icon="fa-plus" text>Add New</btn>
      </template>
      <template slot="table-header">
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Has URL</th>
          <th>Active</th>
          <th class="text-right">Created At</th>
          <th class="text-right">Updated At</th>
          <th class="text-right"></th>
        </tr>
      </template>
      <template slot="table-body">
        <table-row v-for="template in templates" :key="`templates-tr-${template.id}`" :value="template">
          <td>{{ template.id }}</td>
          <td>{{ template.name }}</td>
          <td><badge-active :value="template.has_code_url"/></td>
          <td><badge-active :value="template.active"/></td>
          <td class="text-right">{{ template.created_at }}</td>
          <td class="text-right">{{ template.updated_at }}</td>
          <td class="text-right">
            <btn :route="{ name: 'templates-edit', params: { id: template.id } }" icon="fa-edit">Edit</btn>
            <btn :route="{ name: 'templates-single', params: { id: template.id } }" color="info" icon="fa-eye">Show</btn>
          </td>
        </table-row>
      </template>
    </box-table>
  </div>
</template>

<script>
import BoxSingle from '@/views/components/data/BoxSingle'
import BoxTable from '@/views/components/data/BoxTable'
import Btn from '@/views/components/simple/Btn'
import BadgeActive from '@/views/components/simple/BadgeActive'
import Badge from '@/views/components/simple/Badge'

export default {
  name: 'TemplatesCategoriesSingle',
  metaInfo () {
    return { title: 'Templates | Category #' + this.id }
  },
  components: {
    BoxSingle,
    BoxTable,
    Btn,
    BadgeActive,
    Badge
  },
  computed: {
    id () { return this.$route.params.id }
  },
  data () {
    return {
      category: {},
      templates: []
    }
  }
}
</script>
